<template>
  <b-nav-item-dropdown
    id="dropdown-grouped"
    variant="link"
    class="dropdown-language sf-locale"
    menu-class="sf-nav-menu"
    right
  >
    <template #button-content>
      <span class="sf-nav-chip">
        <feather-icon
          icon="GlobeIcon"
          size="15"
          class="sf-chip-icon"
        />
        <span class="sf-locale-code">{{ localeCode }}</span>
        <feather-icon
          icon="ChevronDownIcon"
          size="14"
          class="sf-chip-caret"
        />
      </span>
    </template>
    <b-dropdown-item
      v-for="localeObj in locales"
      :key="localeObj.locale"
      @click="changeLanguage(localeObj.locale)"
    >
      <b-img
        :src="localeObj.img"
        height="14px"
        width="22px"
        :alt="localeObj.locale"
      />
      <span class="sf-menu-label ml-50">{{ localeObj.name }}</span>
      <feather-icon
        v-if="localeObj.locale === $i18n.locale"
        icon="CheckIcon"
        size="15"
        class="sf-menu-check"
      />
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import store from '@/store'
import { BNavItemDropdown, BDropdownItem, BImg } from 'bootstrap-vue'
import configuracaoContaStoreModule from '@/views/conta/configuracao/configuracaoContaStoreModule'

const CONFIGURACAO_CONTA_STORE_MODULE_NAME = 'configuracao-conta'

// Carregue as imagens fora do escopo do require
const brFlag = require('@/assets/images/flags/pt-br.png')
const enFlag = require('@/assets/images/flags/en.png')
const esFlag = require('@/assets/images/flags/es.png')

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BImg,
  },
  data() {
    return {
      locales: [
        {
          locale: 'pt-br',
          img: brFlag,
          name: 'Brasil',
        },
        {
          locale: 'en',
          img: enFlag,
          name: 'English',
        },
        {
          locale: 'es',
          img: esFlag,
          name: 'Espanha',
        },
      ],
    }
  },
  computed: {
    currentLocale() {
      return this.locales.find(l => l.locale === this.$i18n.locale)
    },
    localeCode() {
      const map = { 'pt-br': 'PT', en: 'EN', es: 'ES' }
      return map[this.$i18n.locale] || this.$i18n.locale.toUpperCase()
    },
  },

  created() {
    if (!store.hasModule(CONFIGURACAO_CONTA_STORE_MODULE_NAME)) store.registerModule(CONFIGURACAO_CONTA_STORE_MODULE_NAME, configuracaoContaStoreModule)
  },

  beforeDestroy() {
    if (store.hasModule(CONFIGURACAO_CONTA_STORE_MODULE_NAME)) store.unregisterModule(CONFIGURACAO_CONTA_STORE_MODULE_NAME)
  },

  methods: {
    changeLanguage(locale) {
      this.$i18n.locale = locale
      store.dispatch('configuracao-conta/setLanguage', { idioma: locale })
        .then(() => {
          const dataUser = JSON.parse(localStorage.getItem('userData'))
          dataUser.idioma = locale
          localStorage.setItem('userData', JSON.stringify(dataUser))
        })
    },
  },
}

</script>

<style>

</style>
